import { config } from '@services/config';
import { QuoteCancelationSearchRequestParams, QuoteCancelationSearchResponse } from '@lio/api-types';
import { useQuery } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const useSearchQuoteCancelation = (
  queryParams: QuoteCancelationSearchRequestParams | { quoteId: undefined },
) => {
  const { quoteId } = queryParams;
  const client = useClient();
  const result = useQuery<QuoteCancelationSearchResponse, Error>({
    queryKey: ['quoteCancelation', { ...queryParams }],
    queryFn: () => client.get(`quote/${quoteId}/cancelation`).json<QuoteCancelationSearchResponse>(),
    enabled: !!quoteId,
    ...config,
  });
  return { ...result, quoteCancelation: result.data };
};
